import axios from 'axios';

const BASE_URL = 'http://localhost:4000';

export const getFuturesAccountInfo = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/fapi/v2/account`);
    // console.log(response.data.assets);
    return response;
  } catch (error) {
    console.error('Error fetching futures account information:', error);
    throw error;
  }
};
